import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import { View } from "react-native";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import navigationHelpers from "app/utils/navigationHelpers";
import valueActions from "app/utils/valueActions";
import chapterActions from "app/utils/chapterActions";
import richTextHelpers from "app/utils/richTextHelpers";
import RichText from "app/components/RichText";

import { StyleContext } from "app/contexts/Style";

export default class VersionedLine extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    // this.state = {};
  }

  componentDidMount = async () => {};

  render() {
    let { line, color } = this.props;
    if (line.replaced) {
      return (
        <View>
          <RichText backgroundColor={"red"}>{line.prevText}</RichText>
          <RichText backgroundColor={"green"}>{line.text}</RichText>
        </View>
      );
    } else if (line.removed) {
      let backgroundColor = colorHelpers.hexToRgbaString(color, 0.2);
      return (
        <RichText
          backgroundColor={backgroundColor}
          textStyle={{ opacity: 0.8, textDecorationLine: "line-through" }}
        >
          {line.text}
        </RichText>
      );
    } else if (line.added) {
      let backgroundColor = colorHelpers.hexToRgbaString(color, 0.2);
      return <RichText backgroundColor={backgroundColor}>{line.text}</RichText>;
    } else {
      return <RichText>{line.text}</RichText>;
    }
  }

  styles = () => {
    return {};
  };
}
